import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPauseFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1536 1344V-64Q1536 -90 1517.0 -109.0Q1498 -128 1472 -128H960Q934 -128 915.0 -109.0Q896 -90 896 -64V1344Q896 1370 915.0 1389.0Q934 1408 960 1408H1472Q1498 1408 1517.0 1389.0Q1536 1370 1536 1344ZM640 1344V-64Q640 -90 621.0 -109.0Q602 -128 576 -128H64Q38 -128 19.0 -109.0Q0 -90 0 -64V1344Q0 1370 19.0 1389.0Q38 1408 64 1408H576Q602 1408 621.0 1389.0Q640 1370 640 1344Z"
	})
});
export default SvgPauseFill;
